export default [
    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
        path: '/main',
        redirect: '/',
        component: () => import('@/layouts/Main.vue'),
        children: [
            {
              path: '/',
              name: 'dashboard',
              component: () => import('@views/Dashboard.vue'),
              meta: {
                title: 'Dashboard',
                authRequired: true,
              }
            },
            {
              path: '/career-profile',
              name: 'career-profile',
              component: () => import('@views/career/CareerProfile.vue'),
              meta: {
                title: "Career Profile",
                authRequired: true,
              },
            },
            {
              path: '/matched-opportunities',
              name: 'matched-opportunities',
              component: () => import('@views/opportunities/OpportunityMatches.vue'),
              meta: {
                title: "List of your applications",
                authRequired: true,
              },
            },
            {
              path: '/applications',
              name: 'applications',
              component: () => import('@views/opportunities/OpportunityMatches.vue'),
              meta: {
                title: "List of your applications",
                authRequired: true,
              },
            },
            {
              path: '/matched-opportunities/:opportunityMatchId(\\d+)',
              name: 'matched-opportunity-view',
              component: () => import('@views/opportunities/OpportunityMatchShow.vue'),
              meta: {
                title: "View your matched opportunity",
                authRequired: true,
              },
            },
            {
              path: '/applications/:opportunityMatchId(\\d+)',
              name: 'application-view',
              component: () => import('@views/opportunities/OpportunityMatchShow.vue'),
              meta: {
                title: "View your matched opportunity",
                authRequired: true,
              },
            },
            {
              path: '/open-opportunities',
              name: 'open-opportunities',
              component: () => import('@views/opportunities/Opportunities.vue'),
              meta: {
                title: "List of open opportunities",
                authRequired: true,
              },
            },
            {
              path: '/open-opportunities/:opportunityId(\\d+)/apply',
              name: 'open-opportunity-apply',
              component: () => import('@views/opportunities/ApplicationCreate.vue'),
              meta: {
                title: "Apply an open opportunity",
                authRequired: true,
              },
            },
            {
              path: '/open-opportunities/:opportunityId(\\d+)',
              name: 'open-opportunity-view',
              component: () => import('@views/opportunities/OpportunityShow.vue'),
              meta: {
                title: "View an open opportunity",
                authRequired: true,
              },
            },
            {
              path: '/interviews',
              name: 'interviews',
              component: () => import('@views/interviews/InterviewList.vue'),
              meta: {
                title: "Interviews",
                authRequired: true,
              }
            },
            {
              path: '/interviews/:invitationId(\\d+)',
              name: 'interview-show',
              component: () => import('@views/interviews/InterviewShow.vue'),
              meta: {
                title: "View Interview",
                authRequired: true,
              },
            },
            {
              path: '/employments',
              name: 'employments',
              component: () => import('@views/employments/EmploymentList.vue'),
              meta: {
                title: "Employments",
                authRequired: true,
              }
            },
            {
              path: '/employments/:offerId(\\d+)',
              name: 'employment-show',
              component: () => import('@views/employments/EmploymentShow.vue'),
              meta: {
                title: "View Employment",
                authRequired: true,
              },
            },
            {
              path: '/training-programs',
              name: 'training-programs',
              component: () => import('@views/training-programs/TrainingProgramList.vue'),
              meta: {
                title: "Training Programs",
                authRequired: true,
              }
            },
            {
              path: '/training-programs/:enrollmentId(\\d+)',
              name: 'training-program-show',
              component: () => import('@views/training-programs/TrainingProgramShow.vue'),
              meta: {
                title: "View Training Program",
                authRequired: true,
              },
            },
            {
              path: '/payments',
              name: 'payments',
              component: () => import('@views/payments/PaymentList.vue'),
              meta: {
                title: "Payments",
                authRequired: true,
              }
            },
            {
              path: '/payments/:recipientId(\\d+)',
              name: 'payment-show',
              component: () => import('@views/payments/PaymentShow.vue'),
              meta: {
                title: "View Payment",
                authRequired: true,
              },
            },
            {
              path: '/notifications',
              name: 'notifications',
              component: () => import('@views/notifications/NotificationList.vue'),
              meta: {
                title: "Notifications",
                authRequired: true,
              }
            },
            {
              path: '/account',
              name: 'account',
              component: () => import('@views/account/UserAccount.vue'),
              meta: {
                title: 'Profile',
                authRequired: true,
              },
            }
        ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
        path: '/full',
        component: () => import('@/layouts/Full.vue'),
        children: [
          {
            path: '/login',
            name: 'login',
            component: () => import('@/views/pages/Login.vue'),
            meta: {
              guestRequired: true,
              title: "Login"
            }
          },
          {
              path: '/error-404',
              name: 'error-404',
              component: () => import('@/views/pages/Error404.vue'),
              meta: {
                title: "404 - Page not Found"
              }
          },
          {
              path: '/error-500',
              name: 'error-500',
              component: () => import('@/views/pages/Error500.vue'),
              meta: {
                title: "500 - Server error"
              }
          },
        ]
    },
    // Redirect to 404 page, if no match found
    {
        path: '/:any(.*)',
        redirect: '/error-404'
    },

]